import React from 'react';
import { LoadingOverlay } from '@mantine/core';

type LoadingSpinnerProps = {
  className?: string;
  testId?: string;
};

export const LoadingSpinner: React.FunctionComponent<LoadingSpinnerProps> = ({
  className,
  testId,
}) => {
  return (
    <LoadingOverlay
      className={className}
      data-testid={testId}
      loaderProps={{ color: 'var(--mantine-color-neutral-8)', size: 'md' }}
      visible
    />
  );
};
